import React from 'react'
import './styles.scss'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { FaGoogle } from 'react-icons/fa'
import { signInWithGoogle, signOut } from '../../firebase/firebase-utils'
import {Link} from 'react-router-dom'

function Joinus(props) {
    return (
        <div className="joinus" id='Joinus'>
            <Container className="Container">
                <Row className="align-items-center">
                    <Col xs={12} lg={6} className="Joinus-text">
                        <h1>Join US</h1>
                        <br />
                        <h5>Do you want to be a part of the TechSeminal ?</h5>
                        <p >
                            We are very excited to introduce to our 'community media' from where 
                            our community members can post feeds and ask any type of queries you 
                            had encountered. Our community members can help in solving the issue for you.
                            Through, this we can solve each other problems and can enjoy learning new 
                            things from others. So, without no delay sign in to our community media...
                     </p>
                    </Col>
                    {props.user ?
                        <Col xs={12} lg={6} className="joinus-btn">
                            <h5>Thanks for joining in our community <br/><span style={{color:'tomato', fontFamily:'Poppins'}}>{props.user.displayName}</span></h5>
                            <Button as={Link} className="Btn" to="/community">Join the discussion</Button>
                            <Button className="Btn" onClick={signOut}>LOGOUT</Button>
                        </Col> :
                        <Col xs={12} lg={6} className="joinus-btn">
                            <h4>Sign In with google and join in the community</h4>
                            <br />
                            <Button className="Btn" onClick={signInWithGoogle}><FaGoogle />&nbsp;SignIn</Button>
                        </Col>
                    }
                </Row>
            </Container>
        </div>
    )
}

export default Joinus
